import { useState, useMemo, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons, { EditButton, DeleteButton } from '../../components/ActionButtons';
import ModalShell from '../../components/ModalShell';
import GeriButon from '../../components/GeriButon';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

// ── Yardımcı Bileşenler ──
function SortIcon() {
  return <span className="ml-1 text-[8px] opacity-30 select-none">⇅</span>;
}

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

const BOS = { ad: '', rezervasyonRenk: '#3b82f6', yetkili: '', komisyon: 0, kdvOrani: 0, kdvDahilMi: true, telefon: '', fax: '', email: '', adres: '', vergiDairesi: '', vergiNo: '', aktifMi: true };

function AcenTeForm({ kayit, onGeri, onKaydet, kaydediliyor, hata }) {
  const [form, setForm] = useState(kayit ? { ...kayit } : { ...BOS });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const INP = (hata) => `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${hata ? 'border-rose-400 bg-rose-50' : 'border-gray-100 focus:border-cyan-400 focus:ring-4 focus:ring-cyan-50 shadow-sm'}`;

  return (
    <ModalShell
      icon={kayit ? '✏️' : '➕'}
      iconColor="from-cyan-600 to-sky-700"
      title={kayit ? `"${kayit.ad}" Düzenle` : 'Yeni Acente & Firma'}
      subtitle="Rezervasyon kanalları ve komisyon yönetimi"
      onClose={onGeri}
      size="xl"
      footer={
        <>
          <button onClick={onGeri} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
          <button onClick={() => onKaydet(form)} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-cyan-600 to-sky-700 hover:from-cyan-700 hover:to-sky-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-cyan-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase">
            {kaydediliyor ? '⌛ KAYDEDİLİYOR...' : '💾 ACENTEYİ KAYDET'}
          </button>
        </>
      }
    >
      <div className="space-y-8">
          {hata && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata}</div>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">İşletme / Acente Adı *</label>
                <input value={form.ad} onChange={e => set('ad', e.target.value.toUpperCase())} className={INP(false)} placeholder="ÖRN: BOOKING.COM, JOLLY TUR..." autoFocus />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Tablo Rengi</label>
                  <div className="flex items-center gap-4 bg-gray-50 border-2 border-gray-100 rounded-2xl p-2 pr-4 shadow-inner transition-all hover:bg-white">
                    <input type="color" value={form.rezervasyonRenk} onChange={e => set('rezervasyonRenk', e.target.value)}
                      className="w-10 h-10 rounded-xl cursor-pointer border-none bg-transparent" />
                    <span className="text-[10px] font-black text-gray-500 uppercase tracking-widest">{form.rezervasyonRenk}</span>
                  </div>
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Komisyon (%)</label>
                  <div className="relative">
                    <input type="number" min="0" max="100" step="0.5" value={form.komisyon} onChange={e => set('komisyon', parseFloat(e.target.value) || 0)} className={INP(false) + ' text-right pr-12'} />
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 font-black text-gray-300 text-xs shadow-inner bg-gray-50 w-7 h-7 flex items-center justify-center rounded-lg border border-gray-100">%</span>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Yetkili Kişi</label>
                  <input value={form.yetkili || ''} onChange={e => set('yetkili', e.target.value.toUpperCase())} className={INP(false)} placeholder="AD SOYAD" />
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Telefon</label>
                  <input type="tel" value={form.telefon || ''} onChange={e => set('telefon', e.target.value)} className={INP(false)} placeholder="+90" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">KDV Oranı (%)</label>
                  <div className="relative">
                    <input type="number" min="0" max="100" step="1" value={form.kdvOrani} onChange={e => set('kdvOrani', parseFloat(e.target.value) || 0)} className={INP(false) + ' text-right pr-12'} />
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 font-black text-gray-300 text-xs shadow-inner bg-gray-50 w-7 h-7 flex items-center justify-center rounded-lg border border-gray-100">%</span>
                  </div>
                </div>
                <div className="flex flex-col justify-end">
                  <label className="flex items-center gap-3 cursor-pointer group w-fit select-none bg-gray-50 px-4 py-3.5 rounded-2xl border-2 border-gray-100 hover:bg-white transition-all h-[46px] mt-auto">
                    <input type="checkbox" className="w-4 h-4 rounded text-cyan-500 focus:ring-cyan-500 border-gray-300" checked={form.kdvDahilMi} onChange={e => set('kdvDahilMi', e.target.checked)} />
                    <span className="text-[10px] font-black text-gray-500 uppercase tracking-widest leading-none">Fiyatlara KDV Dahil</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">E-Posta Adresi</label>
                <input type="email" value={form.email || ''} onChange={e => set('email', e.target.value.toLowerCase())} className={INP(false)} placeholder="iletisim@firma.com" />
              </div>
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Fatura Adresi</label>
                <textarea value={form.adres || ''} onChange={e => set('adres', e.target.value)} rows={3} className={INP(false) + " resize-none leading-relaxed py-4"} placeholder="Tam fatura adresi..." />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Vergi Dairesi</label>
                  <input value={form.vergiDairesi || ''} onChange={e => set('vergiDairesi', e.target.value.toUpperCase())} className={INP(false)} />
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Vergi No</label>
                  <input value={form.vergiNo || ''} onChange={e => set('vergiNo', e.target.value)} className={INP(false)} />
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-50 flex items-center justify-between">
            <label className="flex items-center gap-5 cursor-pointer group w-fit select-none">
              <div className="relative leading-none">
                <input type="checkbox" className="sr-only" checked={form.aktifMi} onChange={() => set('aktifMi', !form.aktifMi)} />
                <div className={`w-14 h-7 rounded-full transition-all duration-300 relative ${form.aktifMi ? 'bg-emerald-500 shadow-lg shadow-emerald-100' : 'bg-gray-200 shadow-inner'}`}>
                  <div className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-md transition-all duration-300 transform-gpu ${form.aktifMi ? 'translate-x-8' : 'translate-x-1'}`} />
                </div>
              </div>
              <div>
                <span className="text-xs font-black text-gray-700 block uppercase tracking-wider leading-none mb-1">İş Ortaklığı Durumu</span>
                <span className={`text-[9px] font-black uppercase tracking-widest leading-none ${form.aktifMi ? 'text-emerald-500' : 'text-gray-400'}`}>
                  {form.aktifMi ? '✓ AKTİF ÇALIŞILABİLİR' : '✗ ŞU AN PASİF'}
                </span>
              </div>
            </label>
          </div>
      </div>
    </ModalShell>
  );
}

export default function AcenteFirma() {
  const [acenteler, setAcenteler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [view, setView] = useState('liste');
  const [secili, setSecili] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [formHata, setFormHata] = useState('');
  const [sortKey, setSortKey] = useState('acenteId');
  const [sortDir, setSortDir] = useState('asc');
  const [colAd, setColAd] = useState('');

  const veriYukle = useCallback(async () => {
    setYukleniyor(true);
    try { setAcenteler((await apiRequest('acenteler')) || []); }
    catch { /* sessiz */ }
    setYukleniyor(false);
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  function handleSort(key) {
    if (sortKey === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir('asc'); }
  }

  async function handleKaydet(form) {
    setKaydediliyor(true); setFormHata('');
    try {
      if (form.acenteId) await apiRequest('acenteler', 'PUT', form);
      else await apiRequest('acenteler', 'POST', form);
      await veriYukle(); setView('liste'); setSecili(null);
    } catch (e) { setFormHata(e?.message || 'Hata oluştu.'); }
    setKaydediliyor(false);
  }

  async function handleSil(id) {
    try { await apiRequest(`acenteler/${id}`, 'DELETE'); setAcenteler(p => p.filter(x => x.acenteId !== id)); setSilOnay(null); }
    catch { alert('Hata oluştu.'); }
  }

  const liste = useMemo(() => {
    return acenteler.filter(a => {
      if (colAd && !a.ad?.toLocaleLowerCase('tr-TR').includes(colAd.toLocaleLowerCase('tr-TR'))) return false;
      return true;
    }).sort((a, b) => {
      let av = a[sortKey], bv = b[sortKey];
      if (sortKey === 'komisyon') { av = Number(av); bv = Number(bv); }
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }, [acenteler, colAd, sortKey, sortDir]);

  const TH = "py-5 px-6 text-[11px] font-black text-gray-400 uppercase tracking-widest text-left cursor-pointer hover:text-cyan-600 transition-colors bg-gray-50/50 select-none whitespace-nowrap";
  const isOpen = view === 'ekle' || view === 'duzenle';

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="🏢"
        iconColor="from-cyan-600 to-sky-700"
        iconShadow="shadow-cyan-200"
        title="Acente & Firmalar"
        subtitle="Rezervasyon kanalları ve komisyon yönetimleri"
      >
        <button onClick={() => { setSecili(null); setView('ekle'); setFormHata(''); }}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-cyan-600 to-sky-700 hover:from-cyan-700 hover:to-sky-800 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-cyan-200 transition-[background-color,transform] duration-300 hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl transition-transform group-hover:rotate-90">＋</span>
          <span className="relative">YENİ ACENTE EKLE</span>
        </button>
      </PageHeader>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: 'TOPLAM KAYIT', value: acenteler.length, icon: '🏢', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
          { label: 'AKTİF ÇALIŞILAN', value: acenteler.filter(a => a.aktifMi).length, icon: '✅', color: 'from-emerald-500 to-emerald-700 shadow-emerald-100' },
          { label: 'PASİF / KAPALI', value: acenteler.filter(a => !a.aktifMi).length, icon: '⛔', color: 'from-rose-500 to-rose-700 shadow-rose-100' },
          { label: 'KOMİSYONLU', value: acenteler.filter(a => a.komisyon > 0).length, icon: '💰', color: 'from-cyan-500 to-blue-700 shadow-cyan-100' },
        ].map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-[box-shadow,transform] duration-300 group`}>
             <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500">{k.icon}</div>
             <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none">{k.label}</p>
             <p className="text-2xl font-black tracking-tight leading-none">{k.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">🔍</span>
            <input value={colAd} onChange={e => setColAd(e.target.value)} placeholder="Acente adı ara..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-cyan-400 focus:outline-none bg-white shadow-sm transition-all font-bold" />
          </div>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-auto whitespace-nowrap">FİLTRELENEN: <b className="text-cyan-600 text-xs">{liste.length}</b> / {acenteler.length}</p>
        </div>

        {/* Mobile View */}
        <div className="md:hidden divide-y divide-gray-100 px-2 leading-none">
          {yukleniyor ? (
            <LoadingSpinner fullPage text="Veriler Çekiliyor..." />
          ) : liste.length === 0 ? (
            <EmptyState icon="🏢" text="Kayıt Bulunamadı" />
          ) : liste.map((a) => (
            <div key={a.acenteId} className={`p-6 flex flex-col gap-5 hover:bg-cyan-50/20 transition-all rounded-[2rem] group ${!a.aktifMi && 'opacity-60 bg-gray-50'}`}>
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-5">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-xl shadow-xl border-2 border-white transform-gpu group-hover:rotate-6 transition-transform duration-500 shadow-cyan-100" style={{ backgroundColor: a.rezervasyonRenk || '#3b82f6' }}>🏢</div>
                  <div className="min-w-0">
                    <p className="font-black text-gray-800 text-base mb-1 tracking-tight uppercase truncate leading-none">{a.ad}</p>
                    <p className="text-[10px] font-black text-cyan-600 uppercase tracking-widest flex items-center gap-1.5 opacity-70 leading-none truncate">{a.yetkili || 'YETKİLİ YOK'}</p>
                  </div>
                </div>
                <span className={`text-[9px] font-black px-2.5 py-1.5 rounded-full border tracking-widest ${a.aktifMi ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-rose-50 text-rose-700 border-rose-100'}`}>
                  {a.aktifMi ? 'AKTİF' : 'PASİF'}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50/50 rounded-2xl p-4 border border-gray-100 shadow-sm">
                  <p className="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-1 leading-none">KOMİSYON</p>
                  <p className="text-sm font-black text-gray-700 leading-none">% {a.komisyon || 0}</p>
                </div>
                <div className="bg-gray-50/50 rounded-2xl p-4 border border-gray-100 shadow-sm">
                  <p className="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-1 leading-none">İLETİŞİM</p>
                  <p className="text-[11px] font-black text-gray-700 truncate leading-none">{a.telefon || a.email || '—'}</p>
                </div>
              </div>
              <div className="flex gap-2">
                <EditButton size="lg" onClick={() => { setSecili(a); setView('duzenle'); }} />
                <DeleteButton size="lg" onClick={() => setSilOnay(a.acenteId)} />
              </div>
            </div>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block overflow-x-auto leading-none">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100 bg-gray-50/50 text-[11px] font-black text-gray-400 uppercase tracking-widest">
                <th className="py-5 px-6 w-12 bg-gray-50/50 text-center">#</th>
                <th onClick={() => handleSort('ad')} className={TH}>Acente Adı <SortIcon field="ad" sortKey={sortKey} sortDir={sortDir} /></th>
                <th className="py-5 px-6 text-left bg-gray-50/50 w-24">Renk</th>
                <th onClick={() => handleSort('yetkili')} className={TH}>Yetkili Kişi <SortIcon field="yetkili" sortKey={sortKey} sortDir={sortDir} /></th>
                <th onClick={() => handleSort('komisyon')} className={TH}>Komis. (%) <SortIcon field="komisyon" sortKey={sortKey} sortDir={sortDir} /></th>
                <th className="py-5 px-6 text-left bg-gray-50/50">İletişim</th>
                <th className="py-5 px-6 text-center bg-gray-50/50 w-32">Durum</th>
                <th className="py-5 px-6 text-right font-black bg-gray-50/50">İşlemler</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {yukleniyor ? (
                <tr><td colSpan={8} className="py-24 text-center font-black text-gray-300 text-[10px] uppercase tracking-widest animate-pulse italic">Veriler Hazırlanıyor...</td></tr>
              ) : liste.length === 0 ? (
                <EmptyState as="td" colSpan={8} icon="🏢" text="Eşleşen kanal bulunamadı" />
              ) : liste.map((a, idx) => (
                <tr key={a.acenteId} className={`group transition-colors duration-200 ${!a.aktifMi ? 'opacity-40 grayscale bg-gray-50/80' : 'hover:bg-cyan-50/30'}`}>
                  <td className="py-5 px-6 text-center font-black text-gray-300 text-xs">{idx + 1}</td>
                  <td className="py-5 px-6">
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white text-xs font-black shadow-lg shadow-cyan-100 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500" style={{ backgroundColor: a.rezervasyonRenk || '#3b82f6' }}>
                        {a.ad?.[0]}
                      </div>
                      <span className="font-black text-gray-700 tracking-tight uppercase text-lg">{a.ad}</span>
                    </div>
                  </td>
                  <td className="py-5 px-6">
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 rounded-lg border-2 border-white shadow-sm ring-1 ring-gray-100 shadow-cyan-50" style={{ backgroundColor: a.rezervasyonRenk || '#3b82f6' }} />
                      <span className="text-[10px] text-gray-400 font-black tracking-tight uppercase">{a.rezervasyonRenk || '#3B82F6'}</span>
                    </div>
                  </td>
                  <td className="py-5 px-6 text-xs font-black text-gray-500 uppercase tracking-tight">{a.yetkili || '—'}</td>
                  <td className="py-5 px-6">
                    <span className="bg-amber-50 text-amber-600 px-3 py-1.5 rounded-xl font-black text-[11px] border border-amber-100 shadow-sm">% {a.komisyon}</span>
                    <div className="mt-1.5 text-[9px] font-bold text-gray-400 uppercase">
                      KDV: %{a.kdvOrani} ({a.kdvDahilMi ? 'Dahil' : 'Hariç'})
                    </div>
                  </td>
                  <td className="py-5 px-6">
                    <p className="text-[11px] font-black text-gray-700 leading-none mb-1.5 uppercase truncate max-w-[140px]">{a.telefon || '—'}</p>
                    <p className="text-[10px] font-bold text-cyan-600 lowercase tracking-normal leading-none truncate max-w-[140px]">{a.email || ''}</p>
                  </td>
                  <td className="py-5 px-6 text-center">
                    <span className={`text-[10px] font-black px-4 py-1.5 rounded-full border tracking-widest shadow-sm ${a.aktifMi ? 'bg-emerald-50 text-emerald-700 border-emerald-100 hover:bg-emerald-500 hover:text-white transition-colors cursor-default' : 'bg-rose-50 text-rose-700 border-rose-100'}`}>
                      {a.aktifMi ? 'AKTİF' : 'PASİF'}
                    </span>
                  </td>
                  <td className="py-5 px-6 text-right font-black">
                    <ActionButtons onEdit={() => { setSecili(a); setView('duzenle'); }} onDelete={() => setSilOnay(a.acenteId)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <UsageInfo
        color="indigo"
        description="Acente ve Anlaşmalı Firmalar modülü, sistem üzerinden rezervasyon yapan kurumların komisyonlarını ve işleyişini yönetir."
        scenarios={[
          { title: "Otomatik Komisyon Hesabı", content: "Buraya eklediğiniz her acente (% komisyon tutarıyla) rezervasyon ekranınıza yansır. Acente rezervasyonlarında otomatik olarak net ve brüt tutarlar ayrıştırılır." },
          { title: "Renk Bazlı Organizasyon", content: "Tıpkı Room Rack panosunda olduğu gibi, acenteleri renklendirerek listelemelerdeki kalabalık verileri tek bakışta analiz edebilirsiniz." }
        ]}
      />

      {isOpen && createPortal(
        <AcenTeForm 
          kayit={secili} 
          onGeri={() => { setView('liste'); setSecili(null); setFormHata(''); }} 
          onKaydet={handleKaydet} 
          kaydediliyor={kaydediliyor} 
          hata={formHata} 
        />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4 backdrop-blur-md animate-fade-in shadow-2xl">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm text-center border border-gray-100">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight uppercase leading-none">Kayıdı Sil</h3>
            <p className="text-[11px] font-black text-gray-500 mt-5 mb-10 leading-relaxed uppercase tracking-tight">
               <b className="text-gray-900">"{acenteler.find(x => x.acenteId === silOnay)?.ad}"</b> kaydı kalıcı olarak silinecek. Emin misiniz?
            </p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-200 transition-all uppercase tracking-widest active:scale-95">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}